import React from 'react'
import { OneColorIconProps, getHexColor } from '../utils'

export const CartIcon: React.FC<OneColorIconProps> = ({ size = 16, color = 'white', className }) => {
  const hex = getHexColor(color)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.4375 12.5C6.4375 13.0178 6.01777 13.4375 5.5 13.4375C4.98223 13.4375 4.5625 13.0178 4.5625 12.5C4.5625 11.9822 4.98223 11.5625 5.5 11.5625C6.01777 11.5625 6.4375 11.9822 6.4375 12.5Z"
        fill={hex}
        stroke={hex}
        strokeWidth="0.125"
      />
      <path
        d="M12.9375 12.5C12.9375 13.0178 12.5178 13.4375 12 13.4375C11.4822 13.4375 11.0625 13.0178 11.0625 12.5C11.0625 11.9822 11.4822 11.5625 12 11.5625C12.5178 11.5625 12.9375 11.9822 12.9375 12.5Z"
        fill={hex}
        stroke={hex}
        strokeWidth="0.125"
      />
      <path
        d="M3.14286 3.5H14.3571L12.7072 9.27472C12.6475 9.48367 12.5214 9.66749 12.3479 9.79835C12.1744 9.92921 11.963 10 11.7457 10H5.7543C5.53699 10 5.3256 9.92921 5.15211 9.79835C4.97862 9.66749 4.85248 9.48367 4.79278 9.27472L2.53218 1.36264C2.50233 1.25816 2.43926 1.16626 2.35252 1.10083C2.26577 1.03539 2.16008 1 2.05142 1H1"
        stroke={hex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
